import React, { useState } from "react";
import { HiCheckCircle, HiXCircle, HiChevronDown } from 'react-icons/hi';

const SofaCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        { 
            question: "Is this service applicable for all types of sofa?", 
            answer: "Yes, our specialists are trained to handle various fabric types including velvet, cotton, polyester, and linen. We use appropriate pH-balanced cleaning agents for each material." 
        },
        { 
            question: "Will this service include hard to reach areas?", 
            answer: "Absolutely. Our process covers a 360-degree deep clean including the back, bottom, side panels, and deep within the crevices where dust accumulates." 
        },
    ];

    const included = [
        "Dry Vacuuming - High-power extraction of dust and debris",
        "Shampooing - Antibacterial foam-based deep sterilization",
        "Wet Vacuuming - Microfiber moisture extraction",
        "Sanitization - Elimination of odors and allergens"
    ];

    const excluded = [
        "Complete removal of decades-old permanent ink stains",
        "Repair of pre-existing structural damage or tears",
        "Cleaning of loose cushions (unless specified)"
    ];

    return (
        <div className="space-y-12">
            {/* Included / Excluded Grid */}
            <div className="grid md:grid-cols-2 gap-8">
                <div className="card-premium p-8 border-l-4 border-l-primary">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm">What's Included</h3>
                    <ul className="space-y-4">
                        {included.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiCheckCircle className="text-primary shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="card-premium p-8 border-l-4 border-l-destructive/30">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm">Not Included</h3>
                    <ul className="space-y-4">
                        {excluded.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiXCircle className="text-destructive opacity-50 shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Premium FAQ Section */}
            <div className="space-y-6">
                <h3 className="text-2xl font-black text-foreground">Service Insights</h3>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div 
                            key={index}
                            className="group rounded-2xl border border-border bg-white overflow-hidden transition-all hover:border-primary/30"
                        >
                            <button 
                                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                                className="w-full px-8 py-6 flex items-center justify-between text-left"
                            >
                                <span className="font-bold text-foreground group-hover:text-primary transition-colors">{faq.question}</span>
                                <HiChevronDown 
                                    className={`text-muted-foreground transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`} 
                                    size={20} 
                                />
                            </button>
                            <div 
                                className={`px-8 transition-all duration-300 ease-in-out ${activeIndex === index ? 'pb-8 max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}
                            >
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {faq.answer}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SofaCleaningInfo;
